module.exports = __webpack_public_path__ + "img/iot7.d22141b1.png";